import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { setDefaultDataSideBar } from "../../redux-toolkit/slices/Layout/LayoutSlice";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

const Sidebar = props => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setDefaultDataSideBar());
  }, []);

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box" style={{ marginTop: 22 }}>
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img
                src="https://vsgroup.vvs.vn/parse/files/SCWASRTWK1Y9AVMP1KFC/6cfc2ceb99c001137f77c23e14cab950_unnamed%201%403x.png"
                alt=""
                style={{ width: "70%" }}
              />
            </span>
            <span className="logo-lg">
              <img
                src="https://vsgroup.vvs.vn/parse/files/SCWASRTWK1Y9AVMP1KFC/6cfc2ceb99c001137f77c23e14cab950_unnamed%201%403x.png"
                alt=""
                style={{ width: "70%" }}
              />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img
                src="https://vsgroup.vvs.vn/parse/files/SCWASRTWK1Y9AVMP1KFC/6cfc2ceb99c001137f77c23e14cab950_unnamed%201%403x.png"
                alt=""
                style={{ width: "70%" }}
              />
            </span>
            <span className="logo-lg">
              <img
                src="https://vsgroup.vvs.vn/parse/files/SCWASRTWK1Y9AVMP1KFC/6cfc2ceb99c001137f77c23e14cab950_unnamed%201%403x.png"
                alt=""
                style={{ width: "70%" }}
              />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100 pt-4">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
